<template>
  <component :is="layout" :loggedIn="loggedIn">
    <slot />
    <transition name="fade" mode="out-in" duration="400">
      <router-view></router-view>
    </transition>
  </component>
</template>

<script>
const default_layout = "default";
export default {
  computed: {
    layout() {
      return (this.$route.meta.layout || default_layout) + "-layout";
    },
    loggedIn() {
      return this.$store.getters.loginState;
    },
  },
  name: "app",
  components: {},
  created() {
    const expires = localStorage.getItem("expires");
    const token = localStorage.getItem("token");
    if (expires && token) {
      var expiresMs = new Date(expires);
      var now = new Date();
      now = now.getTime();
      expiresMs = expiresMs.getTime();
      if (now > expiresMs) {
        this.$store.dispatch("logout");
      } else {
        this.$store.dispatch("login", expiresMs - now);
      }
    }
  },
};
</script>
<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
